<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" :optional="addOptional" opwidth="68px" top="124px" title="新增"
				fontSize="14px" @btnclick="add" :src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :optional="updateOptional" :useAutoOptional="false" opwidth="68px" top="124px" title="修改"
				fontSize="14px" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :optional="delOptional" opwidth="68px" top="124px" title="删除"
				fontSize="14px" @btnclick="del" :src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :optional="saveOptional" opwidth="68px" top="124px" title="保存"
				fontSize="14px" @btnclick="save" :src="require('@/assets/icon/bc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :optional="abolishOptional" opwidth="68px" top="124px" title="取消"
				fontSize="14px" @btnclick="abolish" :src="require('@/assets/icon/qux.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" opwidth="68px" top="124px" title="导出" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div style="width: 980px;">
			<div class="dialogleftMask" v-if="dialogMaskleftfalg"></div>
			<div class="bottom">
				<div class="left" @click="treeClick">
					<div style="margin: 20px;">
						<el-tree :data="datas" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
					</div>
				</div>
				<div class="right">
					<div style="margin: 10px;">
						<template v-for="(item , index) of fromdataadd">
							<Commondropdownlist ref="SaleNodeRef" :key="index" :options="item.options" :btx="item.btx"
								:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
								:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
								:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
								:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
								:checkboxdata="item.checkboxdata" :disabled="item.disabled"
								@remoteMethodtows="remoteMethodtows">
							</Commondropdownlist>
						</template>
					</div>
				</div>
				<div class="dialogMask" v-if="dialogMaskfalg"></div>
			</div>
		</div>
		<div style="height: 40px;">
		</div>
		<!-- <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条指标吗？</span>
    </Dialog> -->
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import fromdataquarter from '../fromData/quarter'
	import fromdataquarterdeit from '../fromData/quarterdeit'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import utils from '../../../../common/utils'
	import {
		PersonGradationList,
		PersonGradationInfo,
		UserInfoList,
		PersonGradationGetMaxGrade,
		PersonGradationAdd,
		PersonGradationEdit,
		CusRelationHospitalDelete,
		PersonGradationDelete,
		PersonGradationExport,
		GetPersonPersonProvinceList,
		GetProvince,
		InventoryClassList
	} from '@/api/home'

	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisiblesU8: false,
				dialogVisiblesU8d: false,
				rightboo: false,
				dwonleft: false,
				treeFlag: false,
				dialogMaskfalg: true,
				dialogMaskleftfalg: false,
				// 按钮falg-begin
				addOptional: true,
				updateOptional: true,
				delOptional: true,
				saveOptional: true,
				abolishOptional: true,
				NodeFlag: false,
				// 按钮falg-end
				ptype: '',
				saveState: null,
				Nodes: null,
				fromdataadd: [],
				fromdataedit: [],
				fromdataquarter: [],
				fromdataquarterdeit: [],
				defaultProps: {
					children: 'Nodes',
					label: 'NodeName'
				},
				datas: [],
				TreeGrade: null,
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
				NodeID: ""
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.fromdataquarter = JSON.parse(JSON.stringify(fromdataquarter))
			this.fromdataquarterdeit = JSON.parse(JSON.stringify(fromdataquarterdeit))
			this.QX()
			this.personGradationList()
			this.personGradationListForEdit()
			this.personGradationGetMaxGrade()
			this.userInfoList()
			this.getProvince();
			this.inventoryClassList();
		},
		methods: {
			// 按钮权限
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 35) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 51) {
								this.qus = items.Nodes
							}
						})
					}
					// console.log(item, 'items');
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						}
					})
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.fromdataadd[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.fromdataadd[3].options.push(obj)
					})
				}
			},
			// 树状下拉
			async personGradationListForEdit() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
				} = await PersonGradationList({
					ForEdit: 1
				})
				if (code == 0) {
					this.fromdataadd[0].options = data
				}
				loading.close();
			},
			// 树状列表
			async personGradationList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
				} = await PersonGradationList({})
				if (code == 0) {
					if (data.length <= 0) {
						// this.addOptional = false
					}
					this.datas = data
				}
				loading.close();
			},
			// 业务员下拉列表
			async userInfoList() {
				let {
					code,
					data
				} = await UserInfoList({
					UserOrg: "00"
				})
			},
			// 获取树的末级节点
			async personGradationGetMaxGrade() {
				let {
					code,
					data
				} = await PersonGradationGetMaxGrade({})
				if (code == 0) {
					this.TreeGrade = data
				}
			},
			// 获取业务员AutoComplete
			async remoteMethodtows(query) {
				let {
					code,
					data
				} = await UserInfoList({
					UserOrg: "00",
					TrueName: query
				})
				if (code == 0) {
					this.fromdataadd[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.UserName,
							value: `${item.TrueName}(${item.UserName})`
						}
						this.fromdataadd[1].options.push(obj)
					})
				}
			},
			// 导出
			async personGradationExport() {
				let resexprot = await PersonGradationExport({})
				if (resexprot) {
					//console.log(resexprot);
					if (resexprot.code == 999) {
						this.$message({
							type: "warning",
							message: resexprot.message
						})
					}
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot.data, `业务员层级${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			Export() {
				this.personGradationExport()
			},
			// 新增接口
			async personGradationAdd() {
				let {
					data,
					code,
					message
				} = await PersonGradationAdd({
					parentCode: this.$refs.SaleNodeRef[0].modelvalue,
					userName: this.$refs.SaleNodeRef[1].modelvalue,
					provinceListInPut: this.$refs.SaleNodeRef[2].modelvalue,
					InvClass: this.$refs.SaleNodeRef[3].modelvalue,
					ShowGrade: this.$refs.SaleNodeRef[4].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "新增成功"
					})
					this.dialogMaskfalg = true //右边禁用
					this.abolishOptional = true //取消禁用
					this.saveOptional = true //保存禁用
					this.dialogMaskleftfalg = false //左边启用
					// this.updateOptional = false //新增启用
					// this.addOptional = true //修改未启用 
					this.delOptional = true //删除启用
					this.$refs.SaleNodeRef[0].modelvalue = '' //右边输入框清空
					this.$refs.SaleNodeRef[1].modelvalue = '' //右边输入框清空
					this.$refs.SaleNodeRef[2].modelvalue = '' //右边输入框清空
					this.$refs.SaleNodeRef[3].modelvalue = '' //右边输入框清空
					this.$refs.SaleNodeRef[4].modelvalue = '' //右边输入框清空
					this.treeFlag = false //是否选中节点（否）
					this.personGradationList()
				} else if (code == 999) {
					this.$message({
						type: "warning",
						message: message
					})
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			// 修改接口
			async personGradationEdit() {
				let {
					data,
					code,
					message
				} = await PersonGradationEdit({
					personCode: this.Nodes.NodeID,
					userName: this.$refs.SaleNodeRef[1].modelvalue,
					parentCode: this.$refs.SaleNodeRef[0].modelvalue,
					provinceListInPut: this.$refs.SaleNodeRef[2].modelvalue,
					InvClass: this.$refs.SaleNodeRef[3].modelvalue,
					ShowGrade: this.$refs.SaleNodeRef[4].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "修改成功"
					})
					this.dialogMaskfalg = true //右边禁用
					this.abolishOptional = true //取消禁用
					this.saveOptional = true //保存禁用
					this.dialogMaskleftfalg = false //左边启用
					// this.updateOptional = false //新增启用
					// this.addOptional = true //修改启用
					this.delOptional = true //删除启用
					this.$refs.SaleNodeRef[0].modelvalue = '' //右边输入框清空
					this.$refs.SaleNodeRef[1].modelvalue = '' //右边输入框清空
					this.$refs.SaleNodeRef[2].modelvalue = '' //右边输入框清空
					this.$refs.SaleNodeRef[3].modelvalue = '' //右边输入框清空
					this.$refs.SaleNodeRef[4].modelvalue = '' //右边输入框清空
					this.treeFlag = false //是否选中节点（否）
					this.personGradationList()
				} else if (code == 999) {
					this.$message({
						type: "warning",
						message: message
					})
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			// 点击修改触发
			update() {
				// this.updateOptional = true //修改禁用
				this.addOptional = true //新增禁用
				this.delOptional = true //删除禁用
				this.saveOptional = false //保存启用
				this.abolishOptional = false //取消启用
				this.dialogMaskfalg = false //右边启用
				this.dialogMaskleftfalg = true //左边禁用
				this.saveState = 1 //新增保存标识
				this.fromdataadd[0].disabled = true
				// 判断选中节点等级如果该树节点等级相等
				// if (this.Nodes.Grade && this.TreeGrade) {
				//   if (this.Nodes.Grade != this.TreeGrade) {
				//     this.fromdataadd[0].inputdata = this.Nodes.NodeID
				//     this.fromdataadd[1].inputdata = ""
				//   }
				// }
			},
			// 新增
			add() {
				this.updateOptional = true //修改禁用
				// this.addOptional = true//新增禁用
				this.delOptional = true //删除禁用
				this.saveOptional = false //保存启用
				this.abolishOptional = false //取消启用
				this.dialogMaskfalg = false //右边启用
				this.dialogMaskleftfalg = true //左边禁用
				this.saveState = 2 //新增保存标识
				this.fromdataadd[1].inputdata = ""
				this.fromdataadd[3].inputdata = ""
				// 判断选中节点等级如果该树节点等级相等
				if (this.Nodes.Grade != this.TreeGrade) {
					this.fromdataadd[0].inputdata = this.Nodes.NodeID
				}
			},
			async PersonGradationDelete() {
				let {
					code,
					data,
					message,
				} = await PersonGradationDelete({
					personCode: this.NodeID,
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功"
					})
					this.personGradationList()
				} else {
					this.$message({
						type: "success",
						message: message
					})
				}
			},
			// 删除
			del() {
				if (this.NodeFlag == true) {
					this.PersonGradationDelete()
					return
				}
				this.$message({
					type: "error",
					message: "请选择您要操作的数据"
				})
			},
			// 保存
			save() {
				if (this.saveState == 2) {
					this.personGradationAdd()
				}
				if (this.saveState == 1) {
					this.personGradationEdit()
				}
			},
			// 取消
			abolish() {
				this.updateOptional = true //修改启用
				this.addOptional = false //新增启用
				this.delOptional = true //删除启用
				this.dialogMaskfalg = true //右边禁用
				this.abolishOptional = true //取消禁用
				this.saveOptional = true //保存禁用
				this.dialogMaskleftfalg = false //左边启用
				this.fromdataadd[0].inputdata = '' //右边输入框清空
				this.fromdataadd[1].inputdata = '' //右边输入框清空
				this.fromdataadd[3].inputdata = ""
				this.treeFlag = false //是否选中节点（否）
				this.fromdataadd[0].disabled = false
				if (this.datas.length <= 0) {
					this.updateOptional = false
				}
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.dialogVisibledel = false
			},
			// 控制取消选中清空事件
			treeClick() {
				this.fromdataadd[0].inputdata = '' //右边输入框清空
				this.fromdataadd[1].inputdata = '' //右边输入框清空
				this.fromdataadd[3].inputdata = ""
				this.treeFlag = false //记录是否选中树状菜单
				this.updateOptional = true //选中修改禁用
				this.addOptional = false //未选中新增禁用
				this.delOptional = true //未选中删除禁用
				this.fromdataadd[2].disabled = true;
			},
			// 获取每一个树状节点
			handleNodeClick(data) {
				console.log(data);
				this.NodeFlag = true
				this.fromdataadd[0].inputdata = data.ParentNodeID
				this.fromdataadd[1].inputdata = data.UserName
				this.fromdataadd[1].options = [{
					key: data.UserName,
					value: data.NodeName
				}]
				this.fromdataadd[3].inputdata = data.InvClass ? data.InvClass : '';
				this.Nodes = data //当前选中的几点等级
				this.treeFlag = true //记录是否选中树状菜单
				this.updateOptional = false //选中修改可用
				this.addOptional = false //选中新增可用
				this.delOptional = false //选中删除可用
				this.NodeID = data.NodeID
				this.fromdataadd[3].disabled = data.Grade === 1 ? false : true;
				if (!data.Nodes) {
					this.fromdataadd[2].disabled = false;
					this.getPersonPersonProvinceList(data.NodeID);
				} else {
					this.fromdataadd[2].disabled = true;
				}
				/////
				this.fromdataadd[4].inputdata = data.ShowGrade
			},
			async getPersonPersonProvinceList(id) {
				let {
					code,
					data,
				} = await GetPersonPersonProvinceList({
					PersonCode: id
				})
				if (code == 0) {
					this.fromdataadd[2].inputdata = data.map(item => item.ProvinceID.toString());
				}
			},
			//省份列表
			async getProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				console.log(data, '省');
				if (code == 0) {
					this.fromdataadd[2].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.fromdataadd[2].options.push(obj)
					})
					console.log(this.fromdataadd[2].options);
				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			}
		},
		watch: {
			datas(newVal) {
				if (newVal.length <= 0) {
					// this.updateOptional = false
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}
		}
	}

	.dialogMask {
		width: 465px;
		height: 533px;
		background-color: #ffffff;
		opacity: 0.5;
		// border: 1px solid red;
		position: absolute;
		margin-left: 490px;
		cursor: no-drop;
		z-index: 999;
	}

	.dialogleftMask {
		width: 465px;
		height: 533px;
		background-color: #ffffff;
		opacity: 0.5;
		// border: 1px solid red;
		position: absolute;
		margin-left: 12px;
		cursor: no-drop;
		z-index: 999;
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.dialogstyle {
		width: 952px;
		height: 100px;
		background: #ffffff;
		border: 1px solid #e6e6e6;
		margin-top: 10px;
	}

	.bottom {
		display: flex;
		justify-content: space-around;
		align-items: center;

		.left {
			width: 465px;
			height: 533px;
			background: #ffffff;
			border: 1px solid #e6e6e6;
			overflow: auto;
		}

		.right {
			width: 465px;
			height: 533px;
			background: #ffffff;
			border: 1px solid #e6e6e6;
			overflow: auto;
		}
	}
</style>
